import { Checkbox } from 'antd'
import {
  CheckboxGroup,
  CheckboxWithCount,
  CountBadge,
  FilterSection,
  FilterTitle,
  LabelCell,
} from 'features/inbox/components/filters/filterElements'
import React, { memo, useCallback, useMemo } from 'react'

export type DRALevelFilterProps = {
  selectedDRAFilters: ReadonlyArray<number>
  countsByDRALevel: Readonly<Record<number, number>>
  onChange: (newFilters: ReadonlyArray<number>) => void
}

const DRALevelFilterComponent: React.FC<DRALevelFilterProps> = ({
  selectedDRAFilters,
  countsByDRALevel,
  onChange,
}) => {
  const handleToggle = useCallback(
    (checked: boolean, level: number) => {
      const currentFilters = selectedDRAFilters
      const next = checked
        ? [...currentFilters, level]
        : currentFilters.filter((dra) => dra !== level)
      onChange(next)
    },
    [onChange, selectedDRAFilters]
  )

  const draLevelsWithCounts = useMemo(
    () =>
      Object.keys(countsByDRALevel)
        .map((key) => parseInt(key, 10))
        .filter((level) => (countsByDRALevel[level] || 0) > 0)
        .sort((a, b) => a - b),
    [countsByDRALevel]
  )

  if (draLevelsWithCounts.length === 0) {
    return null
  }

  return (
    <FilterSection>
      <FilterTitle level={5}>DRA Level</FilterTitle>
      <CheckboxGroup>
        {draLevelsWithCounts.map((level) => (
          <CheckboxWithCount key={level}>
            <LabelCell>
              <Checkbox
                checked={selectedDRAFilters.includes(level)}
                onChange={(e) => handleToggle(e.target.checked, level)}>
                DRA-{level}
              </Checkbox>
            </LabelCell>
            <CountBadge>({countsByDRALevel[level] || 0})</CountBadge>
          </CheckboxWithCount>
        ))}
      </CheckboxGroup>
    </FilterSection>
  )
}

export const DRALevelFilter = memo(DRALevelFilterComponent)
